import _ from 'underscore'
import $ from 'jquery'
import BasicLightbox from '../../BasicLightbox'
import messageResource from '../../messageResource'
import TableTooltip from '../../controls/TableTooltip'
import {escapeHtmlSymbols} from '../../atUtils'
import KEY_HANDLERS, {isEsc} from '../../keyHandlers/index'

function InviteSeveralUsersLightBox(){}

InviteSeveralUsersLightBox.prototype = _.create(BasicLightbox.prototype, {
    exist_invalid_fields_message_key: "user.add_edit.js.footer_error.exist_invalid_fields",
    close_tab_confirmation_message_key: "user.js.invite_several_users.close_tab_confirmation",
    TITLE_TEXT_KEY: "user.js.invite_several_users_popup.title",
    INITIAL_NUMBER_OF_ROWS: 7,

    init: function(inviteUsersData)
    {
        BasicLightbox.prototype.init.call(this, this._getLightBoxId(), "closeInviteSeveralUsersLightBoxBtn");
        $(this.lightBoxEl).removeClass("usersInvited scrollable");
        this.errors = {};
        this.dataChanged = false;
        this.cancel_confirmation_message_key = "user.js.invite_several_users.cancel_confirmation";

        this.titlePlaceholder = document.getElementById(this.lightBoxEl.id + "_titlePlaceholder");
        this.$accountsInvitedSection = $("#" + this.lightBoxEl.id + "_accountCreatedSection");
        this.errorTooltip = new TableTooltip().init(this.lightBoxEl.id + "_inviteSeveralUsersErrorTooltip");
        this.errorTooltip.updateUI = function(config)
        {
            this._tooltipTextPlaceholder.text(config.errorText);
        };

        this.setTitle(messageResource.getMessage(this.TITLE_TEXT_KEY));
        this._generateTable();

        this._bindClickToAddRowsLink("addOneRow", 1);
        this._bindClickToAddRowsLink("addFiveRows", 5);
        this._bindClickToAddRowsLink("addTenRows", 10);

        new BeigeButtonClassesController().init($(this.commitButton)).addListenersIfNeeded();
        new BeigeButtonClassesController().init($(this.cancelButton)).addListenersIfNeeded();

        return this;
    },

    _bindClickToAddRowsLink: function(linkClass, number)
    {
        var self = this;
        this.innerContent.find(".addRowsButtonsContainer ." + linkClass).off("click")
                .on("click", function()
                {
                    self._addEmptyRows(number);
                    return false;
                });
    },

    _getLightBoxId: function()
    {
        return "inviteSeveralUsersLightBox";
    },

    _changesCallback: function()
    {
        this.dataChanged = true;
    },

    setTitle: function(title)
    {
        this.titlePlaceholder.innerHTML = escapeHtmlSymbols(title);
    },

    _generateTable: function(config)
    {
        // abstract
    },

    getDataToCommit: function()
    {
        return [this._getUsersFields()];
    },

    _getUsersFields: function()
    {
        var accounts = [];
        _.each(this.rows, function(row) {
            if (!row.hasNoValues())
            {
                accounts.push(row.getUserFields());
            }
        });
        return accounts;
    },

    updateUI: function()
    {
        _.each(this.rows, function(row) {row.updateUI()});
    },

    validate: function()
    {
        var firstInvalidRow;
        var valid = true;
        _.each(this.rows, function(row)
        {
            if (!row.validate())
            {
                if (_.isUndefined(firstInvalidRow))
                {
                    firstInvalidRow = row;
                }
                valid = false;
            }
        });
        if (firstInvalidRow)
        {
            this.scrollToSection($(firstInvalidRow.getElement()));
        }
        return valid;
    },

    /*
    Offset to show field with error in center of the popup.
     */
    getContentOffset: function()
    {
        return -(this.innerContent.height() / 2);
    },

    hasErrors: function()
    {
        var hasErrors = false;
        $.each(this.rows, function(index, row)
        {
            if (row.hasErrors())
            {
                hasErrors = true;
                return false;
            }
        });
        return hasErrors;
    },

    showServerErrors: function(errors)
    {
        var self = this;
        var minRowNumber = Number.MAX_VALUE;
        _.each(errors, function(error)
        {
            minRowNumber = Math.min(minRowNumber, error.rowNumber);
            self.rows[error.rowNumber].addServerErrors(error.exceptionNames.list);
        });
        if (errors.length > 0)
        {
            this.scrollToSection($(this.rows[minRowNumber].getElement()));
        }
        this.printErrorInFooter(messageResource.getMessage(this.exist_invalid_fields_message_key));
        this.updateUI();
    },

    switchToUsersInvitedState: function(usersInfo)
    {
        $(this.lightBoxEl).addClass("usersInvited");
        this._commitEnabled = false;
        this.dataChanged = false;

        this.$accountsInvitedSection.find(".invitationInfoHeader").text(messageResource.getMessage("user.invite_several_users_popup.invited_users_header"));

        var usersFields = usersInfo;
        var $list = $("<div class='invitedUsersList'>");
        var indexTo = Math.min(7, usersFields.length);
        for (var i = 0; i < indexTo; i++)
        {
            var userInfo = usersFields[i];

            if(userInfo.enabled) {
                var listItem = $("<div>");
                listItem.append("<span class='bullet'>\u2022</span>");
                listItem.append($("<span>").text(userInfo.firstName + " " + userInfo.lastName + " (" + userInfo.email + ")"));
                $list.append(listItem);
            }
        }
        if (usersFields.length > 7)
        {
            var andMoreUsersText = usersFields.length - 7 == 1 ?
                                   messageResource.getMessage("user.created.invite.and_one_more_user") :
                                   messageResource.getMessage("user.created.invite.and_more_users", [usersFields.length - 7]);
            $list.append($("<div class='andMoreUsers'>").text(andMoreUsersText));
        }

        this.$accountsInvitedSection.find(".invitationInfo").empty().append($list);

        this.$accountsInvitedSection.find(".mainContentContainer").css("bottom", (265 - indexTo * 10) + "px");

        this.$accountsInvitedSection.find(".inviteOneMoreButton").css("margin-top", (357 + indexTo * 4) + "px");

        this.$accountsInvitedSection.find(".inviteOneMoreButton span").off("click").click(_.bind(this._switchToInviteUsersState, this));

        this.$accountsInvitedSection.find(".closeLink span").off("click").click(_.bind(this.cancel, this));
    },

    _switchToInviteUsersState: function()
    {
        $(this.lightBoxEl).removeClass("usersInvited scrollable");
        this.errors = {};
        this._commitEnabled = true;
        this._generateTable();
        this.rows[0].setFocus();
    },

    show: function()
    {
        BasicLightbox.prototype.show.call(this);
        this.rows[0].setFocus();
    },

    _addEmptyRows: function(number)
    {
        //abstract
    },

    restoreOnKeyDownHandler() {
        if (this.removeHandler) this.removeHandler()
    },

    setupKeyDownHandler() {
        this.removeHandler = KEY_HANDLERS.onKeyDown((code) => {
            if (isEsc(code)) {
                this.cancel()
                return true
            }
        })
    }
});

export default InviteSeveralUsersLightBox



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/InviteSeveralUsersLightBox.js